import { Injectable } from '@angular/core';
import { Sepa } from '../../dto/sepa';
import { CrudService } from '../../services';
import { HttpParams, HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { toServerDateString } from '../../providers/app-date-adapter';
import { EnumModel } from '../../models/enum-model';
import { DataListModel } from '../../models/data-list-model';
import {BankTransferLoad} from '../../dto/bankTransferLoad';

@Injectable( {
  providedIn: 'root'
} )

export class GpsLoadResponseHistoryService implements CrudService<BankTransferLoad> {
  readonly apiPath = 'gps-load-history/';

  constructor( private http: HttpClient ) { }

  getMany(
    pageIndex: number,
    pageSize: number,
    sortField: string,
    sortDirection: string,
    filterString: string,

    dateFilterCols: string[],
    startFilterDate: Date,
    endFilterDate: Date,
    someAdditionalData: string,
    additionalFilterData?: string[],
    enumFilter?: { key: string; value: string },
    companiesFilter?: string[],

    additionalField1?: string,
    additionalField2?: string,
    additionalValue1?: string,
    additionalValue2?: string

  ): Observable<DataListModel<BankTransferLoad>> {
    let params = new HttpParams()
      .set( 'page', pageIndex.toString() )
      .set( 'pageSize', pageSize.toString() )
      .set( 'filterString', filterString )
      .set( 'sortField', sortField )
      .set( 'sortDirection', sortDirection )

      .set('startFilterDate', toServerDateString(startFilterDate))
      .set('endFilterDate', toServerDateString(endFilterDate))
      .set('someAdditionalData', someAdditionalData)

      .set('additionalField1', additionalField1 == 'null' ? null : additionalField1)
      .set('additionalField2', additionalField2 == 'null' ? null : additionalField2)
      .set('additionalValue1', additionalValue1 == 'null' ? null : additionalValue1)
      .set('additionalValue2', additionalValue2 == 'null' ? null : additionalValue2)
    ;


    if (companiesFilter instanceof Array) {
      companiesFilter.forEach(element => {
        params = params.append('companiesFilter', element);
      });
    }

    if (dateFilterCols instanceof Array) {
      dateFilterCols.forEach(element => {
        params = params.append('dateFilterCols', element);
      });
    }
    if (additionalFilterData instanceof Array) {
      additionalFilterData.forEach(element => {
        params = params.append('additionalFilterData', element);
      });
    }
    if (enumFilter) {
      params = params.append('enumFilter', JSON.stringify(enumFilter));
    }



    return this.http.get( this.apiPath, { params } ) as Observable<DataListModel<BankTransferLoad>>;
  }

  get( id: number ): Observable<BankTransferLoad> {
    return this.http.get( this.apiPath + 'item/' + id ) as Observable<BankTransferLoad>;
  }

  add( item: BankTransferLoad ): Observable<Object> {
    throw new Error( 'Method not implemented.' );
  }
  update( item: Sepa ) {
    throw new Error( 'Method not implemented.' );
    return this.http.put( this.apiPath, item ) as Observable<BankTransferLoad>;
  }

  delete( id: any ) {
    throw new Error( 'Method not implemented.' );
    return this.deleteMany( [ id ] );
  }

  restore( id: any ) {
    throw new Error( 'Method not implemented.' );
    return this.restoreMany( [ id ] );
  }


  deleteMany( idList: any[] ) {
    throw new Error( 'Method not implemented.' );
    let httpParams = new HttpParams();

    idList.forEach( id => {
      httpParams = httpParams.append( 'list', id.toString() );
    } );

    return this.http.delete( this.apiPath, { params: httpParams } );
  }

  restoreMany( idList: any[] ) {
    throw new Error( 'Method not implemented.' );
    let httpParams = new HttpParams();
    idList.forEach( id => {
      httpParams = httpParams.append( 'list', id.toString() );
    } );
    return this.http.patch( this.apiPath, null, { params: httpParams } );
  }




}
